import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Persona } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesFormato, validationSchemaFormato } from "./FormatoCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useFormato, useFormatoDelete, useFormatoUpdate } from "../../hooks/formati"
import FormatoForm from "./FormatoForm"
import { transformErrorForForm } from "../../utils/utils"

export default function FormatoUpdate() {
  const updateFormato = useFormatoUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: formato } = useFormato(Number(id))

  const [modalStateDeleteFormato, modalActionsDeleteFormato] = useModalTrigger()

  const deleteFormato = useFormatoDelete()

  const initialValues = useMemo(() => initialValuesFormato(formato), [formato])
  const validationSchema = useMemo(() => validationSchemaFormato(), [])

  useBreadcrumbs([{ label: "Formati", href: "/edizioni/formati" }, { label: "Dettaglio Formato" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{formato?.nome || <>&nbsp;</>}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteFormato.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateFormato.mutateAsync(values as Persona).then(() => {
                navigate(`/opere/persone`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6">
                  <FormatoForm />
                </Container>
                <BottomFormFixed url="/edizioni/formati" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteFormato.isOpen}
        onClose={modalActionsDeleteFormato.close}
        onDelete={() => {
          return deleteFormato.mutateAsync(formato?.id).then(() => {
            navigate(`/edizioni/formati`)
          })
        }}
        message="Sei sicuro di voler eliminare questo formato?"
        title="Elimina Formato"
      />
    </Layout>
  )
}
